<template>
  <w-sliding-popup ref="groupSlidingPopup" :title="title" type="common" @close="onClosePopup">
    <el-row slot="content" type="flex" justify="space-between">
      <el-col class="mr-r20" :span="14">
        <w-common-obj-list ref="commonObjList" type="physical" :selected-managetype-id="managetypeId" :obj-define-ids="objDefineIds" :objtype-ids="objtypeIds"/>
      </el-col>
      <el-col :span="10">
        <!-- APM2X는 스냅샷 미제공 -->
        <div class="mr-b25">
          <div class="title-h4 dot-title title-bar">기본 정보</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row v-for="basicInfo in basicInfoType" :key="basicInfo[0].prop" type="flex" justify="space-between">
              <el-col v-for="info in basicInfo" :key="`${info.prop}.${info.label}`" :span="12">
                <el-checkbox v-if="objectIsEmpty(info.customerId) || (!objectIsEmpty(info.customerId) && (info.customerId === customer.SKCC || info.customerId === customer.SKT))"
                  :label="info.prop"> {{ info.label }} </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId !== 'SVC'">
          <div class="title-h4 dot-title title-bar">관리자/유지보수 정보</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="objManagerIdMajor"> 관리자(정) </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="objManagerIdMinor"> 관리자(부) </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="maintenanceCompany"> 유지보수 업체 </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="maintenanceManager"> 유지보수 담당자 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-checkbox label="maintenanceTel"> 유지보수 연락처 </el-checkbox>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId === 'SMS' || (managetypeKey === 'ND' && objtypeId !== objtype.WIRELESS_AP)">
          <div class="title-h4 dot-title title-bar">동작상태 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="alivecheckFlagSnmp"> SNMP </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="alivecheckFlagIcmp"> ICMP </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="alivecheckFlagTcpport"> TCP </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="alivecheckTcpPort"> TCP 포트 감지 </el-checkbox>
              </el-col>
            </el-row>
            <el-row v-if="managetypeId === 'SMS'" type="flex" justify="space-between">
              <el-checkbox label="sessionCheckFlag"> 에이전트 상태 감지 </el-checkbox>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId === 'SMS' || (managetypeKey === 'ND' && objtypeId !== objtype.WIRELESS_AP)">
          <div class="title-h4 dot-title title-bar">프로토콜 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="icmpTrycount"> ICMP 시도횟수 </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="icmpTimeout"> ICMP 타임아웃(ms) </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="icmpDatasize"> ICMP 패킷크기(byte) </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="icmpClipingApplyFlag"> ICMP CLI PING </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="snmpTrycount"> SNMP 시도횟수 </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="snmpTimeout"> SNMP 타임아웃(ms) </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId === 'SMS' || (managetypeKey === 'ND' && objtypeId !== objtype.WIRELESS_AP) || managetypeId === 'FMS'">
          <div class="title-h4 dot-title title-bar">SNMP 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="snmpCommunityRead"> 커뮤니티 읽기 </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="snmpCommunityReadwrite"> 커뮤니티 읽기/쓰기 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="snmpVersion"> 버전 </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="snmpPort"> 포트 </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId === 'SMS' || (managetypeKey === 'ND' && objtypeId !== objtype.WIRELESS_AP) || managetypeId === 'FMS'">
          <div class="title-h4 dot-title title-bar">SNMP V3 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="snmpV3Username"> USER </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="snmpV3ContextName"> Context명 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="snmpV3ContextId"> Context ID </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="snmpV3AuthProtocol"> Auth 프로토콜 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="snmpV3AuthPassword"> Auth 비밀번호 </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="snmpV3PrivProtocol"> Privacy 프로토콜 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-checkbox label="snmpV3PrivPassword"> Privacy 비밀번호 </el-checkbox>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId === 'DBMS'">
          <div class="title-h4 dot-title title-bar">기본 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="telnetuserId1"> SSH ID </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="telnetuserPw1"> SSH Password </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-checkbox label="sshPort"> SSH Port </el-checkbox>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId === 'DBMS'">
          <div class="title-h4 dot-title title-bar">Database 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="dbmsGroupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="dbmsService"> SSID </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="dbmsAlias"> 서비스 이름 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="dbmsUserid"> 사용자 ID </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="dbmsUserpw"> 패스워드 </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="showApplicationLink">
          <div class="title-h4 dot-title title-bar">Application Link 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="linkWwwUrl"> Link </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="linkAppPath"> Application </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-b25" v-if="managetypeId !== 'SVC'">
          <div class="title-h4 dot-title title-bar">이벤트 제외 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-checkbox label="eventExceptFlag"> 이벤트 제외 </el-checkbox>
            </el-row>
          </el-checkbox-group>
        </div>

        <div v-if="managetypeId === 'SMS' || (managetypeKey === 'ND' && objtypeId !== objtype.WIRELESS_AP) || managetypeKey === 'VHO' || managetypeKey === 'VVM'">
          <div class="title-h4 dot-title title-bar">장비 접속 설정</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="telnetuserId1"> 1차 접속 ID </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="telnetuserPw1"> 1차 패스워드 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="telnetuserId2"> 2차 접속 ID </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="telnetuserPw2"> 2차 패스워드 </el-checkbox>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="telnetPort"> Telnet 포트 </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="sshPort"> SSH 포트 </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>

        <div class="mr-t25" v-if="((customerId === customer.SKCC || customerId === customer.SKT) && managetypeKey === 'ND')">
          <div class="title-h4 dot-title title-bar">Throughput 정보</div>
          <hr class="mr-b10" />
          <el-checkbox-group v-model="groupItems">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-checkbox label="throughputMax"> Throughput Max </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="throughputLicense"> Throughput 라이선스 </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>

      </el-col>
    </el-row>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" type="solid" size="large" @click="onSaveGroupItems">저장</el-button>
      <el-button size="large" @click="onClosePopup">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import { union, isEmpty as objectIsEmpty } from 'lodash';
import { OBJDEFINE } from '@/constants/objdefine';
import { objtype, objtypeName } from '@/constants/objtype';
import { isEmpty } from '@/utils/basic';
import { getManagetypeKey } from '@/utils/managetype-key';
import msgUtil from '@/utils/message';
import ConfigAPI from '@/api/config/common';
import WCheckPhysicalTree from '@/components/tree/CheckPhysicalTree';
import WCommonObjList from '@/components/table/CommonObjList';
import { customer } from '@/constants/customer-define';

export default {
  name: 'WGroupSavePopup',
  components: {
    WCheckPhysicalTree,
    WCommonObjList,
  },
  props: {
    selectedObj: Object,
    configData: Object,
  },
  data() {
    return {
      customer,
      objtype,
      basicInfo: {
        NETDEVICE: [
          [{ prop: 'objSubnetmask', label: '서브넷마스크' }, { prop: 'objtypeId', label: '장비 종류' }],
          [{ prop: 'objCompanyId', label: '제조사' }, { prop: 'objProductId', label: '모델' }],
          [{ prop: 'objImportance', label: '중요도' }, { prop: 'skccCustomerId', label: '고객사', customerId: 'SKCC' }],
        ],
        AP_CONTROLLER: [
          [{ prop: 'objSubnetmask', label: '서브넷마스크' }, { prop: 'objCompanyId', label: '제조사' }],
          [{ prop: 'objProductId', label: '모델' }, { prop: 'objImportance', label: '중요도' }],
        ],
        WIRELESSAP: [
          [{ prop: 'objCompanyId', label: '제조사' }, { prop: 'objProductId', label: '모델' }],
          [{ prop: 'objImportance', label: '중요도' }],
        ],
        SERVER: [
          [{ prop: 'objSubnetmask', label: '서브넷마스크' }, { prop: 'objImportance', label: '중요도' }],
        ],
        NETINTERFACE: [
          [{ prop: 'netinterfaceName', label: '인터페이스명' }, { prop: 'netinterfaceSpeed', label: '대역폭' }],
        ],
        DBMS: [
          [{ prop: 'objtypeId', label: 'DB 종류' }, { prop: 'objCompanyId', label: '제조사' }],
          [{ prop: 'objProductId', label: 'DB 버전' }, { prop: 'dbmsPort', label: '포트번호' }],
          [{ prop: 'dbmsLockMaxCount', label: 'Lock 최대 개수' }, { prop: 'dbmsSessionMaxCount', label: '세션 최대 개수' }],
          [{ prop: 'objImportance', label: '중요도' }],
        ],
        WAS: [
          [{ prop: 'objProductId', label: 'WAS 버전' }, { prop: 'objImportance', label: '중요도' }],
        ],
        ETC: [
          [{ prop: 'objImportance', label: '중요도' }],
        ],
      },
      groupItems: [],
      dbmsGroupItems: [],
      /**
      * objDefineId 배열. 특정 objDefineId에 해당하는 관리 대상만 선택해야하는 경우 설정한다.
      * @type {Array}
      */
      objDefineIds: null,
      /**
       * objtypeId 배열. 특정 objtypeId에 해당하는 관리 대상만 선택해야하는 경우 설정한다.
       * @type {Array}
       */
      objtypeIds: null,
    };
  },
  computed: {
    customerId() {
      return this.$store.state.common.customerId;
    },
    title() {
      const obj = this.selectedObj.obj;
      if (isEmpty(obj)) {
        return '그룹 저장';
      }
      return obj.objDefineId === 'WIRELESS_DEVICE' ? `${objtypeName[obj.objtypeId]} 그룹 저장` : `${OBJDEFINE[obj.objDefineId]} 그룹 저장`;
    },
    managetypeId() {
      const obj = this.selectedObj.obj;
      return isEmpty(obj) ? null : obj.objManagetypeId;
    },
    managetypeKey() {
      const obj = this.selectedObj.obj;
      return isEmpty(obj) ? null : getManagetypeKey(obj.objManagetypeId, obj.objDefineId, obj.objtypeId);
    },
    /**
     * 선택한 관리 대상의 장비 종류 아이디
     * @author Ju
     * @return {String}
     */
    objtypeId() {
      const obj = this.selectedObj.obj;
      return isEmpty(obj) ? null : obj.objtypeId;
    },
    /**
     * objDefineId별로 기본 정보 항목이 다르다.
     * @return {[type]} [description]
     * @author jda
     */
    basicInfoType() {
      if (objectIsEmpty(this.selectedObj)) {
        return [];
      }
      const obj = this.selectedObj.obj;
      let basicInfoList;
      if (!isEmpty(obj)) {
        basicInfoList = obj.objDefineId === 'WIRELESS_DEVICE' ? this.basicInfo[obj.objtypeId] : this.basicInfo[obj.objDefineId];
      } else {
        basicInfoList = [];
      }
      return isEmpty(basicInfoList) ? this.basicInfo.ETC : basicInfoList;
    },
    /**
     * 가상화의 managetypeKey in ('VHO', 'VVM')만 표현
     * 나머지 모듈은 모두 표현
     * @return {[type]} [description]
     * @author jda
     */
    showApplicationLink() {
      if (this.managetypeId === 'VMS' && this.managetypeKey !== 'VHO' && this.managetypeKey !== 'VVM') {
        return false;
      }
      return true;
    },
  },
  watch: {
    selectedObj: {
      immediate: true,
      handler(value) {
        if (!objectIsEmpty(value) && !objectIsEmpty(value.obj) && (value.obj.objDefineId === 'WIRELESS_DEVICE' || value.obj.objDefineId === 'NETDEVICE')) {
          this.objDefineIds = [value.obj.objDefineId];
          this.objtypeIds = value.obj.objDefineId === 'NETDEVICE' ? null : [value.obj.objtypeId];
        } else {
          this.objDefineIds = null;
          this.objtypeIds = null;
        }
      },
    },
  },
  methods: {
    objectIsEmpty,
    /**
     * [그룹 저장]팝업을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open() {
      this.$refs.groupSlidingPopup.visible = true;
    },
    /**
     * [그룹 저장] 팝업을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.$refs.groupSlidingPopup.visible = false;
      this.reset();
    },
    /**
     * 모듈별 그룹 저장을 한다.
     * @return {[type]} [description]
     * @author jda
     */
    onSaveGroupItems() {
      const configData = this.configData;
      const groupItems = union(this.groupItems, this.dbmsGroupItems);

      const obj = {};
      groupItems.forEach((key) => {
        obj[key] = isEmpty(configData[key]) ? '' : configData[key];
      });

      const objDefineId = this.selectedObj.obj.objDefineId;
      // const tree = this.$refs.targetTree.getTree();
      // let target = null;
      // // VMS의 Group은 애플망고의 Group과 달리 Obj_id 값을 가지고 있기에 분기가 필요하다.
      // if (objDefineId === 'VMS_OBJECT') {
      //   target = filter(tree.getFilteredCheckedNodes(), { obj: { objtypeId: this.managetypeKey } });
      // } else {
      //   target = filter(tree.getFilteredCheckedNodes(), { type: 'obj' });
      // }
      // const checkedTarget = map(uniqBy(target, 'obj.objId'), 'obj.objId');
      const checkedTarget = this.$refs.commonObjList.getSelectedObjList(true);
      if (checkedTarget.length < 1) {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.SELECT, '관리대상'));
        return;
      }

      if (objDefineId === 'DBMS' && this.dbmsGroupItems.length > 0) {
        Object.assign(obj, { dbmsId: configData.dbmsId });
      }

      const action = '그룹 저장';
      const actionTarget = '구성 정보';
      Object.assign(obj, { objIds: checkedTarget, objDefineId });
      ConfigAPI.applyObjGroupConfig(obj).then((response) => {
        if (response.data.success) {
          this.onClosePopup();
        }
        this.$message(msgUtil.getResultMsgData(action, actionTarget, response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, actionTarget, false));
      });
    },
    /**
     * 그룹 저장 항목을 리셋한다.
     * 체크된 관리대상을 해제한다.
     * @author jda
     */
    reset() {
      this.$refs.commonObjList.initData();
      this.groupItems = [];
      this.dbmsGroupItems = [];
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/components/GroupSavePopup.vue